import { Typography } from '@mui/material';

const QnAView = ({data}) => {
  return (
    <Typography paddingLeft={2} variant={'h6'} color={'gray'}>{data.data}</Typography>
  )
}

export default QnAView;
